// extracted by mini-css-extract-plugin
module.exports = {"body":"privacyStyles_body__1K-Ei","listPrivacy":"privacyStyles_listPrivacy__1SOC5","listItem":"privacyStyles_listItem__3FJci"};